import React from 'react';
import PropTypes from 'prop-types';
import { Card, Form, Badge, Row, Col } from 'react-bootstrap-5';
import badgeClass from '../shared/document_badge';

export default function TemplateDefaultPages({ availablePages, templateDefaultPages }) {
  const pages = templateDefaultPages.map((page) => {
    const pageId = typeof page === 'number' ? page : page.id;
    return availablePages.find(availablePage => availablePage.id === pageId);
  }).filter(page => page);

  return (
    <div>
      <div className="my-3">
        <strong className="fw-semibold">Page Defaults</strong>
      </div>
      <p className="my-3">
        The pages that will populate into the "Pages" section of the document editor
      </p>

      {/* Non functional - Needed for spacing alignment */}
      <Form.Group className="search-container invisible mb-3">
        <Form.Control type="text" />
      </Form.Group>

      <Card className="overflow-auto" style={{ maxHeight: '300px' }}>
        <ul className="list-group list-group-flush">
          {pages.map((page, index) => (
            <li className="list-group-item" key={index}>
              <Row className="align-items-center w-100">
                <Col xs={5}>
                  {page.name}
                </Col>
                <Col xs={7}>
                  {page.user_label && (
                    <Badge className={`${badgeClass('user_label')} m-1`}>{page.user_label}</Badge>
                  )}
                  {page.size && (
                    <Badge bg="muted" className={`${badgeClass('size', page.size)} m-1`}>{page.size}</Badge>
                  )}
                </Col>
              </Row>
            </li>
          ))}
        </ul>
        {pages.length === 0 && (
          <Card.Body>
            <div className="text-center text-muted">
              This document does not have any default pages
            </div>
          </Card.Body>
        )}
      </Card>
    </div>
  );
}

TemplateDefaultPages.propTypes = {
  availablePages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired,
  templateDefaultPages: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      template_type: PropTypes.string.isRequired
    })
  ])).isRequired
};
